<template>
  <div id="main-content" class="add-parent">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>

      <form>
        <el-row class="row-section">
          <h3>{{ $t('studentApprove.infoParent') }}</h3>
        </el-row>
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.name }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.gender') }}:</span>
            <span class="info-span" v-if="studentEdit.parent.gender">{{ $t('common.male') }}</span>
            <span class="info-span" v-else>{{ $t('common.female') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.furigana') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.furigana }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.romaji') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.romaji }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.email') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.email }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('common.phone') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.phone }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.address_1') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.address_1 }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('common.address_2') }}:</span>
            <span class="info-span"> {{ studentEdit.parent.address_2 }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.member') }}:</span>
            <span class="info-span" v-if="studentEdit.parent.is_member">{{ $t('common.yes') }}</span>
            <span class="info-span" v-else>{{ $t('common.no') }}</span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable" style="width: 20%">{{ $t('common.active') }}</span>
            <span class="info-span">{{ studentEdit.parent.is_active ? $t('common.yes') : $t('common.no') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable" style="width: 20%">{{ $t('common.image') }}</span>
            <img class="info-span" v-bind:src="studentEdit.parent.image" width="30%"/>
          </el-col>
        </el-row>
        <el-row class="row-section">
          <h3>{{ $t('common.basic_information') }}</h3>
        </el-row>
        <div>
          <el-row>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.full_name') }}</span>
              </el-col>
              <input class="input" v-model="studentEdit.fullname" type=""/>
              <el-col v-if="error_message.fullname" :offset="8" :span="16">
                <span class="form-error">{{error_message.fullname}}</span>
              </el-col>
            </el-col>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.class') }}</span>
              </el-col>
              <select style="" class="input" v-model="studentEdit.class_id">
                <option value="">{{ $t('common.please_select') }}</option>
                <option v-for="classroom in sortedClassList" v-bind:key="classroom.id" :value="classroom.id">{{
                    classroom.name }}
                </option>
              </select>
              <el-col v-if="error_message.class" :offset="8" :span="16">
                <span class="form-error">
                  {{error_message.class}}
                </span>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.furigana') }}</span>
              </el-col>
              <input class="input" v-model="studentEdit.furigana" type=""/>
              <el-col v-if="error_message.furigana" :offset="8" :span="16">
                <span class="form-error">{{error_message.furigana}}</span>
              </el-col>
            </el-col>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="form-lable">{{ $t('common.romaji') }}</span>
              </el-col>
              <input class="input" v-model="studentEdit.romaji" type=""/>
              <el-col v-if="error_message.romaji" :offset="8" :span="16">
                <span class="form-error">{{error_message.romaji}}</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.gender') }}</span>
              </el-col>
              <select style="" class="input" v-model="studentEdit.gender">
                <option value="0">{{ $t('common.female') }}</option>
                <option value="1">{{ $t('common.male') }}</option>
              </select>
            </el-col>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.relation_type') }}</span>
              </el-col>
              <select style="" class="input" v-model="studentEdit.relation_type">
                <option value="0">{{ $t('common.unknown') }}</option>
                <option value="1">{{ $t('common.second_child') }}</option>
                <option value="2">{{ $t('common.first_child') }}</option>
              </select>
              <el-col v-if="error_message.relation" :offset="8" :span="16">
                <span class="form-error">{{error_message.relation}}</span>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="required-star">* </span><span class="form-lable">{{ $t('common.bus_stop') }}</span>
              </el-col>
              <select style="" class="input" v-model="studentEdit.place_id">
                <option value="">{{ $t('common.please_select') }}</option>
                <option v-for="place in sortedPlaceList" v-bind:key="place.id" :value="place.id">{{ place.name }}</option>
              </select>
              <el-col v-if="error_message.place"  :offset="8" :span="16">
                <span class="form-error">{{error_message.place}}</span>
              </el-col>
            </el-col>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="form-lable">{{ $t('common.building_info') }}</span>
              </el-col>
              <input class="input" v-model="studentEdit.building_info" type=""/>
            </el-col>
          </el-row>
          <el-row style="padding-top: 20px">
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="form-lable">{{ $t('common.room_number') }}</span>
              </el-col>
              <input class="input" v-model="studentEdit.room_number" type=""/>
            </el-col>
            <el-col :span="12" style="display: inline">
              <el-col :span="8">
                <span class="form-lable">{{ $t('common.active') }}</span>
              </el-col>
              <el-switch style="float: left;" v-model="studentEdit.is_active"></el-switch>
            </el-col>
          </el-row>
        </div>
        <el-row style="padding: 50px 0">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="onSaveData">{{ $t('common.submit') }}
          </el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>
<script>
import PageTitle from "@/components/PageTitle";
import {basicSort, classSort} from "@/utils";
import {mapState} from "vuex";
export  default {
  data(){
    return{
      studentEdit: {
        fullname: "",
        furigana: "",
        romaji: "",
        class_id: "",
        parent_id: "",
        place_id: "",
        gender: 0,
        relation_parent: "",
        relation_type: 0,
        building_info: "",
        room_number: "",
        is_active: true,
        parent:{
          name: "",
          furigana: "",
          romaji: "",
          email: "",
          phone: "",
          is_member: false,
          gender: 0,
          address_1: '',
          address_2: '',
          image: '',
          is_active: true,
        }
      },
      error_message: {
          fullname: '',
          furigana:null,
          romaji: null,
          class:null,
          place: null,
          relation: null,
        },
      title:'studentApprove.titleDetail',
      backLink: '/student/list-wait-approve',
    }
  },
  components: {
    PageTitle
  },
  computed:{
    ...mapState('classroom', ['classList']),
    ...mapState('place', ['placeList']),
    sortedClassList: function () {
      let sortedClassList = [].concat(this.classList)
      sortedClassList.sort((before, after) => classSort(before, after))
      return sortedClassList
    },
    sortedPlaceList: function () {
      let sortedPlaceList = [].concat(this.placeList)
      sortedPlaceList.sort((before, after) => basicSort(before, after, 'name'))
      return sortedPlaceList
    }
  },
  created() {
    if(this.$route.query.sid){
      let id = this.$route.query.sid
      this.onGetStudentById(id)

    }
  },
  mounted: function () {
    this.$store.dispatch('classroom/retrieveClassList', {})
    this.$store.dispatch('place/retrievePlaceList', {})
  },
  methods:{
    onGetStudentById(id){
      let successCallback = (response) =>{
        if(response.status ===200){
          this.studentEdit = Object.assign({}, response.data.data.student)
        }
      }
      let errorCallback = () =>{}

      let payload = {
        successCallback,
        errorCallback,
        student_id : id
      }
      this.$store.dispatch('parent/getDetailApproveStudent', payload)
    },
    validSpecialChar: function (text) {
      let specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      return specialChar.test(text)
    },
    onResetErr:function () {
      let error = {
        fullname: '',
        furigana:null,
        romaji: null,
        class:null,
        place: null,
        relation: null,
      }
      this.error_message = error
    },
    onSaveData(){
      let check = this.onValidate(this.studentEdit)
      if(check){
        let successCallback = (response) => {
          if(response.status ===200){
            this.$router.push('/student/list-wait-approve')
          }
        }
        let errorCallback = ()=>{}
        let student = Object.assign({}, this.studentEdit)
        student.is_approve = 1
        let payload = {
          successCallback,
          errorCallback,
          data : student
        }
        if(student.is_active){
          this.$store.dispatch('parent/updateApproveStudent', payload)
        }else{
          this.$store.commit('openConfirm', {
            title: this.$t('common.confirm'),
            message: this.$t('msg.notActiveStudent'),
            callback: () => {
              this.$store.dispatch('parent/updateApproveStudent', payload)
            }
          })
        }
      }
    },
    onValidate(value) {
      this.onResetErr()
      let check = true
      if (!value.fullname) {
        check = false
        this.error_message.fullname = '* ' + this.$t('common.name_is_required_child')
      }
      if (this.validSpecialChar(value.fullname)) {
        check = false
        this.error_message.fullname = '* ' + this.$t('common.name_cannot_contain_special_character_child')
      }
      if (!value.furigana) {
        check = false
        this.error_message.furigana = '* ' + this.$t('common.name_is_required_child')
      }
      if (this.validSpecialChar(value.furigana)) {
        check = false
        this.error_message.furigana = '* ' + this.$t('common.name_cannot_contain_special_character_child')
      }
      if (!value.class_id) {
        check = false
        this.error_message.class = '* ' + this.$t('common.class_is_required')
      }

      if (!value.place_id) {
        check = false
        this.error_message.place=  '* ' + this.$t('common.bus_stop_is_required')
      }

      if (value.relation_parent === "") {
        check = false
        this.error_message.relation = '* ' + this.$t('common.relation_is_required')
      }
      return check
    },
  }
}
</script>
